<template>
  <div class="vue-app">
    <NotFoundGoodsForm />
  </div>
</template>

<script>
import OQClientApi from "@/api/OQClientApi";
import NotFoundGoodsForm from "@/components/NotFoundGoodsForm";

export default {
  name: "AppNotFoundGoodsForm",
  components: { NotFoundGoodsForm },
  data() {
    return {
      cart_from_uri: undefined,
      order_id: undefined,
    };
  },
  mounted() {
    const params = window.location.search
      .substring(1)
      .split("&")
      .map((v) => v.split("="))
      .reduce((a, v) => {
        a[v[0]] = v[1];
        return a;
      }, {});
    const cart = JSON.parse(localStorage.globalCart || "{}");
    const productName = params.cartItemId;
    if (productName) {
      this.order_id = OQClientApi.getProductNameOrder(productName);
      if (cart[productName]) {
        this.cart_from_uri = {
          productName,
          product: cart[productName],
        };
      } else {
        this.order_id = undefined;
      }
    }
  },
  methods: {
    clearOrder() {
      this.cart_from_uri = undefined;
      this.order_id = undefined;
    },

    doOffer(order) {
      console.log(order);
    },
  },
};
</script>

<style lang="scss"></style>
